import { Compass } from "lucide-react";
import { Link } from "react-router";
import { Button, EmptyState } from "@hostdock/ui";

export function NotFoundPage() {
  return (
    <EmptyState
      icon={Compass}
      title="Page not found"
      description="The page you're looking for doesn't exist or has moved."
      action={
        <Link to="/">
          <Button size="sm">Back to home</Button>
        </Link>
      }
    />
  );
}
